import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgRuntime = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: "1em",
	height: "1em",
	viewBox: "0 0 36 36",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		d: "M18 1.5c9.113 0 16.5 7.387 16.5 16.5S27.113 34.5 18 34.5 1.5 27.113 1.5 18 8.887 1.5 18 1.5Zm0 2.368C10.195 3.868 3.868 10.195 3.868 18S10.195 32.132 18 32.132 32.132 25.805 32.132 18 25.805 3.868 18 3.868Zm-4.102 8.009c1.504 0 2.612.35 3.324 1.05.723.688.95 1.667.681 2.938-.175.828-.524 1.527-1.048 2.099a4.975 4.975 0 0 1-1.837 1.295l1.486 4.302a.29.29 0 0 1 .017.088.479.479 0 0 1-.017.105.423.423 0 0 1-.157.263.488.488 0 0 1-.297.105h-2.31c-.221 0-.373-.053-.455-.158a1.974 1.974 0 0 1-.157-.315l-1.172-3.848h-1.802l-.822 3.884a.5.5 0 0 1-.192.314.556.556 0 0 1-.35.123H6.533A.37.37 0 0 1 6.236 24c-.058-.081-.076-.186-.052-.314l2.414-11.37a.502.502 0 0 1 .192-.316.556.556 0 0 1 .35-.122h4.758Zm15.44 0c.128 0 .22.04.28.122.07.082.093.187.07.316l-.403 1.87a.57.57 0 0 1-.192.316.488.488 0 0 1-.332.122h-3.114l-1.924 9.062a.5.5 0 0 1-.193.314.489.489 0 0 1-.332.123h-2.31a.37.37 0 0 1-.296-.123c-.07-.081-.094-.186-.07-.314l1.94-9.062H19.35a.35.35 0 0 1-.28-.122.38.38 0 0 1-.07-.316l.402-1.87a.534.534 0 0 1 .175-.316.557.557 0 0 1 .35-.122h9.41ZM10.68 17.335h2.028c.548 0 .986-.134 1.313-.402.326-.269.542-.636.647-1.103.093-.455.034-.822-.176-1.101-.198-.28-.583-.42-1.154-.42h-2.012l-.646 3.026Z",
		fill: "currentColor"
	})]
});
const ForwardRef = forwardRef(SvgRuntime);
export { ForwardRef as ReactComponent };
